<template>
  <modal-default
    ref="modal"
    title="Select Snippet"
    :short-circuit-close="true"
    @close="cancelAndClose"
  >
    <template v-if="snippets.length">
      <button
        v-for="snippet in snippets"
        class="snippet_item"
        @click="selectSnippet(snippet)"
      >
        {{ snippet.label }}
      </button>

      <hr class="mb-50">
      <p class="snippet_link">Edit snippets on the <router-link :to="{name: 'settings', params: {tab: 'snippets'}}">snippets setting page</router-link></p>
    </template>
    <p v-else class="snippet_empty">You have no snippets set up, you can set some up on the
      <router-link :to="{name: 'settings', params: {tab: 'snippets'}}">Snippets Setting Page</router-link>
    </p>
  </modal-default>
</template>

<script>
import ModalBase from "../../../modal/ModalBase";
import {destroyModal} from "../../../../services/modals";

export default {
  name: "SnippetsSelectModal",
  components: {ModalBase},
  props: {
    snippets: {
      type: Array,
      required: true
    },
  },
  mounted() {
    this.$refs.modal.open();
  },
  computed: {
    contactName() {
      return this.$utils.displayFullName(this.duplicateContact.full_name);
    }
  },
  methods: {
    selectSnippet(snippet) {
      this.$emit("selectedSnippet", snippet);
      destroyModal(this.$refs.modal);
    },
    cancelAndClose() {
      destroyModal(this.$refs.modal);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/variables/variables";

.snippet_item {
  display: block;
  margin-bottom: 8px;
  font-size: 1rem;
  font-family: $sans-family;
  color: $secondary;

  &:hover {
    color: $primary;
  }
}

.snippet_link {
  color: $text-light;
  font-size: 0.8rem;
  text-align: center;
}

.snippet_empty {
  padding: 1rem 0 1.5rem;
  font-style: italic;
  line-height: 1.3;
}
</style>
